import {ArticlePublicationListItem} from '../ArticlePublicationListItem';
import {BookChapterPublicationListItem} from '../BookChapterPublicationListItem';
import {BookPublicationListItem} from '../BookPublicationListItem';

export interface PublicationListItemProps {
  publication: Research.PublicPublicationDto;
}

export function PublicationListItem({publication}: PublicationListItemProps) {
  if (publication.type === 'book') {
    return <BookPublicationListItem publication={publication} />;
  } else if (publication.type === 'bookChapter') {
    return <BookChapterPublicationListItem publication={publication} />;
  }

  return <ArticlePublicationListItem publication={publication} />;
}
